import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/Typography';
import { formatPrice } from '@utils/format';
import styles from './ProductsList.module.css';

interface ProductsListProps {
    products: { name: string; image: string; price: number; quantity: number }[];
}

export const ProductsList: FC<ProductsListProps> = ({ products }) => {
    const { t } = useTranslation();

    const translations = {
        quantityLabel: t('shopping-cart-total-component.order-summary.quantity-label'),
    };

    return (
        <>
            {products.length > 0 && (
                <div className={`${styles['product-summary']}`} data-testid="products-list">
                    {products.map((product, index) => (
                        <div key={`order-item-${index}`} className={styles.indent}>
                            {index !== 0 && <hr className="my-0" />}
                            <div className="d-flex gap-3 align-items-center text-decoration-none my-3">
                                <div>
                                    <img className="product-image" src={product.image} alt={product.name} />
                                </div>
                                <div className="d-grid flex-grow-1">
                                    <Typography classes="text-truncate mb-2" fontSize="16" color="dark" fontWeight="900">
                                        {product.name}
                                    </Typography>
                                    <div className="d-flex justify-content-between">
                                        <Typography classes="text-truncate mb-0" fontSize="14" color="muted">
                                            <>{`${translations.quantityLabel} ${product.quantity}`}</>
                                        </Typography>
                                        <Typography classes="text-truncate mb-0" fontSize="14" color="muted" align="right">
                                            {formatPrice(product.price)}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};
